import { create as createAxios, type AxiosInstance } from 'axios';

import { applyBaseUrl, axiosConfig, camelizeResponse } from './axiosConfig';

// Auth endpoints are called without apiClient's bearer-token interceptor:
// login should not try to refresh an old session before accepting credentials,
// and refresh must not recurse through the 401 replay path.
export const authClient: AxiosInstance = createAxios(axiosConfig);

// Needed here too, not just on apiClient — `axiosConfig` carries no `baseURL`, so
// without this every auth call would go to a relative URL. See `applyBaseUrl`.
authClient.interceptors.request.use(applyBaseUrl);
authClient.interceptors.response.use(camelizeResponse);
